/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const FullscreenExitIcon = /*#__PURE__*/ createSvgIcon(
  'FullscreenExitIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.667 15.333H2.889a.86.86 0 01-.633-.255.86.86 0 01-.256-.634.86.86 0 01.256-.633.86.86 0 01.633-.255h2.667a.86.86 0 01.633.255.86.86 0 01.255.633v2.667a.86.86 0 01-.255.633.86.86 0 01-.633.256.86.86 0 01-.634-.256.86.86 0 01-.255-.633v-1.778zm10.666 0v1.778a.86.86 0 01-.255.633.86.86 0 01-.634.256.86.86 0 01-.633-.256.86.86 0 01-.255-.633v-2.667a.86.86 0 01.255-.633.86.86 0 01.633-.255h2.667a.86.86 0 01.633.255.86.86 0 01.256.633.86.86 0 01-.256.634.86.86 0 01-.633.255h-1.778zM4.667 4.667V2.889a.86.86 0 01.255-.633A.86.86 0 015.556 2a.86.86 0 01.633.256.86.86 0 01.255.633v2.667a.86.86 0 01-.255.633.86.86 0 01-.633.255H2.889a.86.86 0 01-.633-.255A.86.86 0 012 5.556a.86.86 0 01.256-.634.86.86 0 01.633-.255h1.778zm10.666 0h1.778a.86.86 0 01.633.255.86.86 0 01.256.634.86.86 0 01-.256.633.86.86 0 01-.633.255h-2.667a.86.86 0 01-.633-.255.86.86 0 01-.255-.633V2.889a.86.86 0 01.255-.633.86.86 0 01.633-.256.86.86 0 01.634.256.86.86 0 01.255.633v1.778z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default FullscreenExitIcon;
